import { defineStore } from "pinia";
import { createBaseStoreRefactor } from "./baseStoreRefactor";

// Create base store configuration for account categories
const accountCategoriesBaseStore = createBaseStoreRefactor({
  endpoint: "/api/v1/account_categories",
  name: "AccountCategoriesStoreRefactor",
  objectName: "Categorie", // Auto-generates CRUD success messages
  enableCache: true, // Enable caching since categories rarely change
  actionCableChannel: null, // No real-time updates needed
  infiniteLoading: false, // Simple list, no pagination needed
});

export const useAccountCategoriesStoreRefactor = defineStore(
  "accountCategoriesRefactor",
  {
    ...accountCategoriesBaseStore,

    getters: {
      ...accountCategoriesBaseStore.getters,

      /**
       * Get all categories (maps to state.data for compatibility)
       */
      categories: (state) => {
        return state.data || [];
      },

      /**
       * Get category by ID
       */
      getCategoryById: (state) => (id) => {
        return state.data.find((category) => category.id == id);
      },

      /**
       * Get active categories only (if categories have an active field)
       */
      activeCategories: (state) => {
        return state.data.filter((category) => category.active !== false);
      },
    },

    actions: {
      ...accountCategoriesBaseStore.actions,

      // All methods including CRUD operations are fully inherited from base store
      // Auto-generated messages use "Categorie" from objectName
    },
  },
);
